import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import MenuList from "@mui/material/MenuList";
import { useListContext } from "react-admin";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import { filter } from "lodash";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "rgba(0, 0, 0, 0.08)";
  let textColor = "#000";

  return (
    <Box sx={{ width: "100%" }}>
      {type}
      {/* <Chip
        label={appCounts}
        size="small"
        className="numericText"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          backgroundColor: chipBgColor,
          color: textColor,
        }}
      /> */}
    </Box>
  );
};

const ReportListNewAside = ({ ...props }) => {
  let filterValues = "";
  let selected = "";
  let filteryear = "";
  let filterReportType = "";
  if (props?.selected == "monthreport") {
    selected = props?.selected;
    filteryear = "current";
  } else {
    const { filterValues, isPending } = useListContext();
    // console.log("filterValues", filterValues);
    if (isPending) return "Loading...";
    selected = props?.selected ? props?.selected : filterValues.status;
    filterReportType = filterValues?.reportType;
    filteryear = filterValues?.year;
  }
  const totalData = props?.totalData;
  const authrole = localStorage.getItem("authrole");
  return (
    <>
      <HmSubHeaderTitle
        title="Reports"
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1 }}>
          <MenuList component="div" id="list-report-menus">
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Daily Activity Reports
            </Typography>
            <CustomMenuItemLink
              id="list-daily-report-menus"
              to='/monthreport?filter={"status":"monthreport"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Reports" />}
              selected={selected == "monthreport"}
            />
            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Historic Reports
            </Typography>
            {/* <CustomMenuItemLink
              to='/reports?filter={"status":"Inception to Date"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Inception to Date" />}
              selected={selected == "Inception to Date" && !filterReportType}
            /> */}
            <CustomMenuItemLink
              to='/reports?filter={"status":"Inception to Date","reportType":"applications"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Applications" />}
              selected={
                selected == "Inception to Date" &&
                filterReportType == "applications"
              }
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"Inception to Date","reportType":"loans"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Loans" />}
              selected={
                selected == "Inception to Date" && filterReportType == "loans"
              }
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"Inception to Date","reportType":"customers"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Customers" />}
              selected={
                selected == "Inception to Date" &&
                filterReportType == "customers"
              }
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"Inception to Date","reportType":"achpayments"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="ACH Payments" />}
              selected={
                selected == "Inception to Date" &&
                filterReportType == "achpayments"
              }
            />

            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Loan Servicing Reports
            </Typography>
            <CustomMenuItemLink
              to='/reports?filter={"status":"Loan Portfolio"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Month End Loan Portfolio" />}
              selected={selected == "Loan Portfolio"}
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"Disbursements"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Monthly Disbursements" />}
              selected={selected == "Disbursements"}
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"Repayments"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Monthly Repayments" />}
              selected={selected == "Repayments"}
            />
            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Customized Reports
            </Typography>
            <CustomMenuItemLink
              to='/reports?filter={"status":"monthly_underwriting"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Monthly Report" />}
              selected={selected == "monthly_underwriting"}
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"weekly_applications"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Weekly Report" />}
              selected={selected == "weekly_applications"}
            />
            <CustomMenuItemLink
              to='/reports?filter={"status":"Metro II"}'
              state={{ _scrollToTop: true }}
              primaryText={<AppMenuTitle type="Metro II" />}
              selected={selected == "Metro II"}
            />
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default ReportListNewAside;
